import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "wrapper"
};
const _hoisted_2 = {
  class: "wrapper-top-left"
};
const _hoisted_3 = {
  class: "collapse"
};
const _hoisted_4 = {
  class: "collapse-title"
};
const _hoisted_5 = {
  class: "footer"
};
const _hoisted_6 = {
  key: 1,
  class: "span-btn"
};
const _hoisted_7 = {
  key: 1,
  class: "audit-result"
};
const _hoisted_8 = {
  class: "audit-result-item"
};
const _hoisted_9 = {
  class: "audit-result-val"
};
const _hoisted_10 = {
  class: "audit-result-item"
};
const _hoisted_11 = {
  class: "audit-result-val"
};
const _hoisted_12 = {
  class: "wrapper-top-right"
};
import PrintedItem from './PrintedItem';
import PrintedTimeline from "./PrintedTimeline";
import { onMounted, reactive, ref } from "vue";
import { ElMessage } from 'element-plus';
import apis from "@/api";
import { useRoute, useRouter } from "vue-router";
import MngerAudit from "../components/MngerAudit";
export default {
  __name: 'Detail',
  setup(__props) {
    const tags = ref([]);
    const activeAsset = ref(null);
    const printedLoading = ref(false);
    const route = useRoute();
    const router = useRouter();
    const data = reactive({
      auditDialogShow: false,
      // 源数据
      printedAssets: [],
      printedDemand: {},
      fileUrl: "",
      demandId: route.query.demandId,
      disabled: false,
      demandAuditLog: {}
    });
    onMounted(() => {
      queryPrintedTags();
      queryPressworkInfoByDemandId();
      queryDemandAuditLog();
    });
    const queryDemandAuditLog = () => {
      apis.getDemandAudit({
        demandId: data.demandId
      }).then(res => {
        if (res.success) {
          data.demandAuditLog = res.data;
        }
      });
    };
    const showAuditDialog = () => {
      data.auditDialogShow = true;
    };

    // 标签查询
    const queryPrintedTags = () => {
      const param = {
        pageNo: 1,
        pageSize: 50,
        parNum: 'printed-types'
      };
      printedLoading.value = true;
      apis.queryTagByParNum(param).then(res => {
        if (res && res.success) {
          res.data.records.forEach(item => {
            const tag = {
              name: item.tagNum,
              label: item.tagName
            };
            tags.value.push(tag);
          });
        } else {
          ElMessage.error(res.msg);
        }
        printedLoading.value = false;
      }).catch(err => {
        ElMessage.error(err);
        printedLoading.value = false;
      });
    };
    const toBack = () => {
      router.go(-1);
    };

    // 根据印刷品需求ID查询对应的素材
    const queryPressworkInfoByDemandId = () => {
      let params = {
        demandId: data.demandId
      };
      apis.queryPressworkAssets(params).then(res => {
        if (res && res.success) {
          data.printedAssets.length = 0;
          let responseData = res.data;
          data.printedDemand = res.data;
          let pressworkDetailList = responseData.listDetail;
          if (pressworkDetailList) {
            pressworkDetailList.forEach((item, index) => {
              data.printedAssets[index] = {
                srcInnUrl: item.imageUrl,
                types: item.tagList,
                dateRange: [item.startDate, item.endDate],
                desc: item.des,
                assetsName: item.imageName,
                pressworkId: item.id,
                id: item.id
              };
            });
            data.demandId = responseData.demandId;
            data.fileUrl = responseData.fileUrl;
            data.disabled = true;
            data.id = responseData.id;
          }
        } else {
          ElMessage.error(res.msg);
        }
      }).catch(err => {
        ElMessage.error(err);
      }).finally(() => {
        if (data.printedAssets && data.printedAssets.length > 0) {
          activeAsset.value = data.printedAssets[0].id;
        }
      });
    };
    const downloadFile = () => {
      window.open(data.printedDemand.fileUrl);
    };
    return (_ctx, _cache) => {
      const _component_el_collapse_item = _resolveComponent("el-collapse-item");
      const _component_el_collapse = _resolveComponent("el-collapse");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _directive_has = _resolveDirective("has");
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
        gutter: 24,
        class: "wrapper-top"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_card, {
          class: "wrapper-top-left-card",
          shadow: "hover"
        }, {
          header: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createElementVNode("div", {
            class: "card-header"
          }, [_createElementVNode("span", null, "新增印刷品制作需求")], -1)]))]),
          default: _withCtx(() => [_createVNode(_component_el_collapse, {
            modelValue: activeAsset.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => activeAsset.value = $event)
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.printedAssets, (item, index) => {
              return _openBlock(), _createBlock(_component_el_collapse_item, {
                key: index,
                name: item.id
              }, {
                title: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("span", null, _toDisplayString(item.assetsName), 1)])])]),
                default: _withCtx(() => [_createVNode(_unref(PrintedItem), {
                  disabled: data.disabled,
                  asset: item,
                  tags: tags.value
                }, null, 8, ["disabled", "asset", "tags"])]),
                _: 2
              }, 1032, ["name"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_row, {
          class: "wrapper-file"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, null, {
            default: _withCtx(() => [_cache[4] || (_cache[4] = _createElementVNode("span", {
              style: {
                "color": "red"
              }
            }, "*", -1)), _cache[5] || (_cache[5] = _createElementVNode("span", null, "印刷品制作附件:", -1)), _cache[6] || (_cache[6] = _createElementVNode("span", {
              class: "span-btn"
            }, "下载模版", -1)), data.printedDemand.fileName ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "span-btn",
              onClick: downloadFile
            }, _toDisplayString(data.printedDemand.fileName), 1)) : _createCommentVNode("", true), !data.disabled ? (_openBlock(), _createElementBlock("span", _hoisted_6, "上传附件")) : _createCommentVNode("", true), _cache[7] || (_cache[7] = _createElementVNode("span", null, null, -1))]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, {
          class: "wrapper-btn"
        }, {
          default: _withCtx(() => [data.printedDemand.status == 0 ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            type: "primary",
            onClick: showAuditDialog
          }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode("审核", -1)]))]),
            _: 1
          })), [[_directive_has, 'printed-audit-btn']]) : (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_cache[9] || (_cache[9] = _createElementVNode("div", {
            class: "audit-result-label"
          }, "审核状态：", -1)), _createElementVNode("div", _hoisted_9, _toDisplayString(data.printedDemand.status == 1 ? '通过' : '驳回'), 1)]), _createElementVNode("div", _hoisted_10, [_cache[10] || (_cache[10] = _createElementVNode("div", {
            class: "audit-result-label"
          }, "审核内容：", -1)), _createElementVNode("div", _hoisted_11, _toDisplayString(data.demandAuditLog.optRemark), 1)])]))]),
          _: 1
        })])]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_el_card, {
          shadow: "hover"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_tabs, null, {
            default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
              label: "需求流程"
            }, {
              default: _withCtx(() => [_createVNode(_unref(PrintedTimeline), {
                demandId: data.demandId,
                class: "wrapper-top-right-timeline"
              }, null, 8, ["demandId"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })])]),
        _: 1
      }), _createVNode(_unref(MngerAudit), {
        visible: data.auditDialogShow,
        "onUpdate:visible": _cache[1] || (_cache[1] = $event => data.auditDialogShow = $event),
        demandId: data.demandId,
        "onUpdate:demandId": _cache[2] || (_cache[2] = $event => data.demandId = $event),
        onSuccess: toBack
      }, null, 8, ["visible", "demandId"])])), [[_directive_loading, printedLoading.value]]);
    };
  }
};